module.exports = __webpack_public_path__ + "img/background.1864c79d.jpg";